import { useFormik } from "formik";
import React from "react";
import { useSaveBalanceReceiptFormMutation } from "state/api";
import { paymentMethodDropdown } from "./processDropdown";
import { Autocomplete, Button, TextField } from "@mui/material";

const BalanceReceipt = ({ data, setLoader }) => {
  const [saveBalanceReceipt] = useSaveBalanceReceiptFormMutation();

  const formik = useFormik({
    initialValues: {
      balanceReceiptDate:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
      paymentMode: paymentMethodDropdown[0],
    },
    onSubmit: (values) => {
      values.transactionId = data._id;
      setLoader(true);
      saveBalanceReceipt(values)
        .unwrap()
        .then((res) => {
          alert("Balance Receipt Saved");
          setLoader(false);
          window.location.reload();
        })
        .catch((err) => {
          alert("Balance Receipt Failed");
          setLoader(false);
        });
    },
  });

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">
        Balance Receipt
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="balanceAmount"
            name="balanceAmount"
            label="Balance Amount"
            type="number"
            value={data?.bookingForm?.balanceAmount}
            fullWidth
            disabled
          />
          <TextField
            id="bookingAmount"
            name="bookingAmount"
            label="Booking Amount"
            type="number"
            value={data?.bookingForm?.bookingAmount}
            fullWidth
            disabled
          />
          <TextField
            id="totalAmount"
            name="totalAmount"
            label="Total Amount"
            type="number"
            value={data?.bookingForm?.totalAmount}
            fullWidth
            disabled
          />
          <TextField
            id="balanceReceiptDate"
            name="balanceReceiptDate"
            label="Balance Receipt Time"
            type="datetime-local"
            value={formik.values.balanceReceiptDate}
            onChange={formik.handleChange}
            fullWidth
          />

          <Autocomplete
            id="paymentMode"
            name="paymentMode"
            options={paymentMethodDropdown}
            getOptionLabel={(option) => option}
            value={formik.values.paymentMode}
            onChange={(event, newValue) => {
              formik.setFieldValue("paymentMode", newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Payment Mode" />
            )}
            fullWidth
          />

          <Button
            type="submit"
            className="my-2 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Submit
          </Button>
        </div>
      </form>
    </>
  );
};

export default BalanceReceipt;
